/** 建築物用途 */
export const BUILDING_USAGE = {
  UNSELECTED: '-1',
  DETACHED_HOUSE: '01',
  TOWN_HOUSE: '02',
  APARTMENT: '03',
  STORE_HOUSE: '04',
  STORE: '05',
  OFFICE: '06',
  HOTEL: '07',
  PUBLIC_FACILITIES: '08',
  HOSPITAL: '09',
  NURSERY_SCHOOL: '10',
  FACTORY: '11',
  STORAGE: '12',
  SCHOOL: '13',
  GYMNASIUM: '14',
  THEATER: '15',
  OTHER: '99'
} as const
